import { URItoBlob } from './uri-to-blob';

export const openPDFInWindow = (pdf: string) => {
  const url = URL.createObjectURL(URItoBlob(pdf));
  window.open(url, '_blank');
};
